module.exports = __webpack_public_path__ + "img/jiaozi-1.0f89e523.jpg";